/**
 * ░██████╗░██╗████████╗██╗░░██╗██╗░░░██╗██████╗░  ██╗
 * ██╔════╝░██║╚══██╔══╝██║░░██║██║░░░██║██╔══██╗  ╚═╝
 * ██║░░██╗░██║░░░██║░░░███████║██║░░░██║██████╦╝  ░░░
 * ██║░░╚██╗██║░░░██║░░░██╔══██║██║░░░██║██╔══██╗  ░░░
 * ╚██████╔╝██║░░░██║░░░██║░░██║╚██████╔╝██████╦╝  ██╗
 * ░╚═════╝░╚═╝░░░╚═╝░░░╚═╝░░╚═╝░╚═════╝░╚═════╝░  ╚═╝
 * 
 * ███╗░░██╗░█████╗░████████╗██╗░░██╗░█████╗░███╗░░██╗███████╗██╗░░██╗░█████╗░
 * ████╗░██║██╔══██╗╚══██╔══╝██║░██╔╝██╔══██╗████╗░██║██╔════╝██║░██╔╝██╔══██╗
 * ██╔██╗██║██║░░██║░░░██║░░░█████═╝░██║░░██║██╔██╗██║█████╗░░█████═╝░██║░░██║
 * ██║╚████║██║░░██║░░░██║░░░██╔═██╗░██║░░██║██║╚████║██╔══╝░░██╔═██╗░██║░░██║
 * ██║░╚███║╚█████╔╝░░░██║░░░██║░╚██╗╚█████╔╝██║░╚███║███████╗██║░╚██╗╚█████╔╝
 * ╚═╝░░╚══╝░╚════╝░░░░╚═╝░░░╚═╝░░╚═╝░╚════╝░╚═╝░░╚══╝╚══════╝╚═╝░░╚═╝░╚════╝░
 */

if (typeof window !== 'undefined') {
  console.log(
    `%c
░██████╗░██╗████████╗██╗░░██╗██╗░░░██╗██████╗░  ██╗
██╔════╝░██║╚══██╔══╝██║░░██║██║░░░██║██╔══██╗  ╚═╝
██║░░██╗░██║░░░██║░░░███████║██║░░░██║██████╦╝  ░░░
██║░░╚██╗██║░░░██║░░░██╔══██║██║░░░██║██╔══██╗  ░░░
╚██████╔╝██║░░░██║░░░██║░░██║╚██████╔╝██████╦╝  ██╗
░╚═════╝░╚═╝░░░╚═╝░░░╚═╝░░╚═╝░╚═════╝░╚═════╝░  ╚═╝

███╗░░██╗░█████╗░████████╗██╗░░██╗░█████╗░███╗░░██╗███████╗██╗░░██╗░█████╗░
████╗░██║██╔══██╗╚══██╔══╝██║░██╔╝██╔══██╗████╗░██║██╔════╝██║░██╔╝██╔══██╗
██╔██╗██║██║░░██║░░░██║░░░█████═╝░██║░░██║██╔██╗██║█████╗░░█████═╝░██║░░██║
██║╚████║██║░░██║░░░██║░░░██╔═██╗░██║░░██║██║╚████║██╔══╝░░██╔═██╗░██║░░██║
██║░╚███║╚█████╔╝░░░██║░░░██║░╚██╗╚█████╔╝██║░╚███║███████╗██║░╚██╗╚█████╔╝
╚═╝░░╚══╝░╚════╝░░░░╚═╝░░░╚═╝░░╚═╝░╚════╝░╚═╝░░╚══╝╚══════╝╚═╝░░╚═╝░╚════╝░
    `,
    'color: #c084fc; font-weight: bold; font-family: monospace; text-shadow: 0 0 10px rgba(192, 132, 252, 0.5);'
  );
}

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);